import { DEACTIVE_TOUR, ACTIVE_TOUR } from '../constants'

const defaultState = {
  // usado quando o usuario ja viu o tutorial
  // e quer ver novamente quando clica no menu
  active: false,
}

export default (state = defaultState, action) => {
  switch (action.type) {
  case ACTIVE_TOUR:
    return {
      ...state,
      active: true,
    }
  case DEACTIVE_TOUR:
    return {
      ...state,
      active: false,
    }
  default:
    return state
  }
}
